import React from 'react'
import { Page, PageContent, Icon, Text } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { ModalPopup } from './'

class CoachModal extends React.Component {

  onClose() {
    if(window.localStorage){
      localStorage.setItem('sleep-trainer-toolkit', '1');
    }
    this.props.app.toggleModal();
  }

  render() {
    let props = this.props;
    return (
        <ModalPopup {...props}>
          <Page name="CoachModal" style={{ position: 'relative' }}>
            <PageContent>
              <div style={{ maxWidth: '90rem', fontSize: '130%', padding: '2rem' }}>
                <Text>Dit hoofdstuk is bedoeld voor alle trainers sleep&pushback die werkzaam zijn bij de afhandelaren op Schiphol. In dit hoofdstuk vind je een aantal documenten die jou helpen bij het vormgeven van de opleiding voor sleep- en pushbackchauffeurs. Zo is er een checklist die je er af en toe bij kan pakken om even te stil te staan bij de manier waarop je lesgeeft. Ook vind je hier de richtlijnen voor de theorie- en praktijkexamens.</Text>
                <br/>
                <Text>Aan het eind van ieder hoofdstuk in deze e-Learning kan de deelnemer een overzicht uitprinten met een aantal praktijkopdrachten. Deze staan hier voor jou ook gebundeld in 1 document.</Text>
              </div>
            </PageContent>

            <a onClick={this.onClose.bind(this)} className="Modal-popup-close">
              <Icon name="close" />
            </a>
          </Page>
        </ModalPopup>
    )
   }
}

export default CoachModal
